module.exports = __webpack_public_path__ + "img/hontai_L8149.52321cbb.png";